import $ from 'jquery';
import _ from 'underscore';

import * as analytics from 'analytics/Analytics';
import {ANALYTICS_MODULE, ACTION_CATEGORY} from 'constants/AnalyticsConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as ExportDAO from 'exports/ExportDAO';
import * as featurelibrary from 'molbio/feature-libraries/FeatureLibrary';
import * as FeatureLibraryConstants from 'molbio/feature-libraries/FeatureLibraryConstants';
import ImportFeatureLibraryModal from 'molbio/feature-libraries/ImportFeatureLibraryModal';
import LibraryView, {LibraryViewOptions} from 'molbio/feature-libraries/LibraryView';
import notifications from 'notifications';
import OwnablesManageView, {OwnablesManageViewOptions} from 'profile/OwnablesManageView';
import runModal from 'ui-library/runModal';
import {formatRows} from 'util/ExportUtil';
import {BasicEvent} from 'util/Types';

let featureLibrariesCollection: featurelibrary.Collection | null = null;

class FeatureLibrariesView extends OwnablesManageView<featurelibrary.Model> {
  el!: string;
  type!: string;
  modelType!: string;
  libraryView!: LibraryView;
  ownables!: featurelibrary.Collection;

  static initClass(): void {
    this.prototype.el = '.js-feature-libraries';
    this.prototype.type = 'feature-libraries';
    this.prototype.modelType = ModelTypeConstants.FEATURE_LIBRARY;
  }
  events(): Backbone.EventsHash {
    // eslint-disable-next-line no-restricted-syntax
    return _.extend(super.events(), {
      'submit .create-new form': 'createNewLibrary',
      'submit .edit-permissions': 'addCollaborator',
      'click .ape-import': function () {
        return this.import(FeatureLibraryConstants.ImportType.APE);
      },
      'click .csv-import': function () {
        return this.import(FeatureLibraryConstants.ImportType.CSV);
      },
    });
  }

  static getBootstrappedOwnables(): featurelibrary.Collection {
    if (featureLibrariesCollection == null) {
      featureLibrariesCollection = new featurelibrary.Collection(window.bootstrap!.feature_libraries);
    }
    return featureLibrariesCollection;
  }

  initialize(options: OwnablesManageViewOptions<featurelibrary.Model>): void {
    this.libraryView = new LibraryView({
      libraryMember: featurelibrary.Feature,
      collectionName: 'features',
    } as LibraryViewOptions);
    super.initialize(options);
  }

  die(): void {
    super.die();
    this.libraryView.die();
  }

  import(type: FeatureLibraryConstants.ImportType): Promise<void> {
    const libraries = this.ownables;
    const navigateToOwnable = this.navigateToOwnable.bind(this);
    return runModal(ImportFeatureLibraryModal, {
      isCSVImport: type === FeatureLibraryConstants.ImportType.CSV,
      libraries: this.ownables
        .filter((ownable) => ownable.get('permissions').writable)
        .map((ownable) => ownable.toJSON()),
    }).then((result) => {
      if (result == null) {
        return;
      }
      const {file, libraryId, matchType} = result;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('library_id', libraryId.toString());
      formData.append('owner_id', window.bootstrap!.current_entity_id!);
      formData.append('file_type', type);
      formData.append('match_type', matchType);
      $.ajax({
        url: '/1/api/feature-libraries/import',
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        type: 'POST',
      })
        .done((res) => {
          notifications.success('File successfully imported.');
          let importedIntoLibrary = new featurelibrary.Model(res);
          importedIntoLibrary = libraries.add(importedIntoLibrary, {merge: true});
          navigateToOwnable(importedIntoLibrary.id);
          analytics.track('feature_library', 'imported_features', {
            product: ANALYTICS_MODULE.MOLBIO,
            actionCategory: ACTION_CATEGORY.WRITE,
            featureLibraryId: importedIntoLibrary.get('api_identifier'),
            fileType: type,
          });
        })
        .fail(notifications.notifyError);
    });
  }

  createNewLibrary(e: BasicEvent): Promise<unknown> {
    e.preventDefault();
    const library = new featurelibrary.Model({
      name: this.$el.find('.create-new .name').val(),
      description: this.$el.find('.create-new .description').val(),
      owner_id: window.bootstrap!.current_entity_id,
    });
    return library
      .save()
      .done(() => {
        this.ownables.add(library);
        this.$el.find('.create-new .name').val('');
        this.$el.find('.create-new .description').val('');
        this.navigateToOwnable(library.id);
        notifications.success('Library created successfully!');
        analytics.track('feature_library', 'created', {
          product: ANALYTICS_MODULE.MOLBIO,
          actionCategory: ACTION_CATEGORY.WRITE,
          featureLibraryId: library.get('api_identifier'),
        });
      })
      .fail(notifications.notifyError);
  }

  handleExport(): void {
    const rows = this.currentOwnable
      .get('features')
      .toArray()
      .map((feature: featurelibrary.Feature) => [
        feature.get('name'),
        feature.get('bases'),
        feature.get('feature_type'),
        feature.get('color'),
        feature.get('match_type'),
      ]);

    ExportDAO.downloadStringContents(
      `${this.currentOwnable.get('name')}.csv`,
      `Name,Feature,Type,Color,Match type\n${formatRows(rows, ',')}`
    );
    analytics.track('feature_library', 'exported', {
      product: ANALYTICS_MODULE.MOLBIO,
      actionCategory: ACTION_CATEGORY.READ,
      featureLibraryId: this.currentOwnable.get('api_identifier'),
    });
  }

  renderOwnable(): void {
    super.renderOwnable();

    const library = this.currentOwnable;
    this.libraryView.update(library);
    this.libraryView.render();
    $.getJSON(`/1/api/feature-libraries/${library.id}/collaborators/`)
      .done((collaborators) => {
        this.createCollaboratorsView(collaborators, {
          onExport: () => {
            this.handleExport();
          },
        });
      })
      .fail(notifications.notifyError);
  }
}
FeatureLibrariesView.initClass();

export default FeatureLibrariesView;
